import styled from 'styled-components';
import { BLACK, NEUTRAL_150, PALE_BLUE } from '../../styles/colors';
import { GIVONIC } from '../../styles/fonts';

export const TabContainer = (styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${NEUTRAL_150};
  width: 100%;
  border-radius: 32px;
  padding: 8px 3%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const TabItemContainer = (styled.div<{ $isActive: boolean; $tabCount?: number }>`
  padding: 12px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: ${({ $tabCount }: { $tabCount?: number }) => $tabCount ? `${100 / $tabCount}%` : '50%'};
  border-radius: 32px;
  ${({ $isActive }: { $isActive: boolean }) => $isActive && `
    background: linear-gradient(117deg, #C9ECFF, #82ADFF, #7B69FF, #9B1BFF);
  `}
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const TabItemText = (styled.span<{ $isActive: boolean }>`
  color: ${({ $isActive }: { $isActive: boolean }) => $isActive ? PALE_BLUE : BLACK};
  font-size: 13px;
  font-family: ${GIVONIC.regular};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
